// extracted by mini-css-extract-plugin
module.exports = {"loading":"Spinner_loading__1blBM"};